<template>
  <div class="wrapper">
    <div class="main-panel">
      <top-navbar :nameDashboard="name"></top-navbar>
      <div class="mt-5" style="background-color: #d6d8db; height: 100%;" >
        <dashboard-content @click="toggleSidebar">

      </dashboard-content>
      </div>
      <content-footer></content-footer>

    </div>
    <side-bar style="z-index: 1050;">
      <mobile-menu slot="content"></mobile-menu>
      <div style="font-size: 15px;">
      <li class="py-2 "   >
        <div class=" rounded-lg py-2 px-4 button-bcl" style="padding-right: 0rem !important;" href="#homeDashboard" data-toggle="collapse">
          <b-icon-graph-up font-scale="1.5"></b-icon-graph-up>
            <a class="px-2 text-white  " aria-expanded="false">Injury Indicators</a>
          <b-icon-caret-down-fill></b-icon-caret-down-fill>
          <ul class="collapse px-3 py-1" id="homeDashboard" @click.stop  style="padding-right: 0rem !important;">
            <li class="py-1"><router-link class="p-3 text-white " to="/dashboard/Muscle-Capacity" @click.native="NameTop('Injury Indicators: Muscle Capacity')">Muscle Capacity</router-link></li>
            <li class="py-1"><router-link class="p-3 text-white" to="/dashboard/Player-Comparison" @click.native="NameTop('Injury Indicators: Player-Comparison ')" >Player Comparison</router-link></li>
          </ul>

        </div>

      </li>


        <li class="py-2" >
        <div class=" rounded-lg py-2 px-4 button-bcl " style="padding-right: 0rem !important;" data-toggle="collapse">
          <b-icon-bar-chart-line font-scale="1.5"></b-icon-bar-chart-line>
          <router-link  class=" p-2 text-white" to="/dashboard/Personalized-Zones"  @click.native="NameTop('Personalized Zones ')"><a>Personalized Zones</a></router-link>
        </div>
        </li>


      <li class="  py-2" >
        <div class=" rounded-lg py-2 px-4 button-bcl " style="padding-right: 0rem !important;"  data-toggle="collapse">
          <b-icon-graph-up font-scale="1.5"></b-icon-graph-up>
          <router-link class=" p-2 text-white" to="/dashboard/prediction" @click.native="NameTop('Predictions ')">Predictions</router-link>

        </div>
      </li>


      </div>


    </side-bar>



  </div>



</template>

<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    data(){
      return{
        name:''
      }
    },
    created() {
        //if(localStorage.getItem('page_name')) {
        //  this.name = localStorage.getItem('page_name')
       // }
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      noActive(){
        addEventListener('click', ()=> this.show = true)
      },
      NameTop(name){
        console.log(name)
         localStorage.setItem('page_name', name)
       // if(localStorage.getItem('page_name')) {
       //   this.name = localStorage.getItem('page_name')
       // }else{
          this.name=name
        //}
        //this.name=name
      }
    }
  }

</script>

<style>
.button-bcl:hover {
  background-color:rgba(236, 236, 236, 0.2);
}

.router-link-exact-active {
  color: #000000 !important;
}
</style>
